import React from "react";
import { Link } from "react-router-dom";
import featureFlags from "utils/featureFlags";

import { OldStyledList, StyledList } from "./style";

interface Props {
  linkText: string;
  linkTo: string;
  onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const StyledListComponent = featureFlags.rebrand ? StyledList : OldStyledList;

const NestedNavLink: React.FC<Props> = ({
  linkText,
  linkTo,
  onClick,
}: Props) => (
  <StyledListComponent
    className="navbar-item"
    data-test-id={`nested-nav-link-${linkText
      .replace(/\s/g, "-")
      .toLowerCase()}`}
  >
    <Link to={linkTo} onClick={onClick}>
      {linkText}
    </Link>
  </StyledListComponent>
);

export default NestedNavLink;
